<template>
  <div class="Home-list">
    <v-container grid-list-xl fluid>
      <template v-if="user" >
        <v-row>
          <v-col cols="12" sm="8" md="8" >
            <div v-for="bloc in user.profilInterface.blocs" :key="bloc" >
              <notificationList class="mb-5" v-if="bloc == 'notificationList'"></notificationList>
              <qualityCheckList class="mb-5" v-if="bloc == 'qualityCheckList'"></qualityCheckList>
              <ticketList class="mb-5" v-if="bloc == 'ticketList'"></ticketList>
            </div>
          </v-col>
          <v-col cols="12" sm="4" md="4" >
            <div v-for="bloc in user.profilInterface.blocs" :key="bloc" >
              <productionList class="mb-5"  v-if="bloc == 'productionList'"/>
              <notificationList class="mb-5"  v-if="bloc == 'notificationListRight'"/>
              <articleList class="mb-5"  v-if="bloc == 'articleList'"/>
              <appList class="mb-5"  v-if="bloc == 'appListRight'"/>

            </div>
          </v-col>
        </v-row>
      </template>
      </v-container>
  </div>
</template>

<script>
  import { mapActions,mapState,mapGetters } from 'vuex';
  import ListMixin from '../../mixins/ListMixin';
  import AccessMixin from '../../mixins/AccessMixin';
  import productionList from '../../components/product/Production';
  import qualityCheckList from '../../components/qualitycheck/List';
  import notificationList from '../../components/notification/List';
  import ticketList from '../../components/ticket/List';
  import appList from '../../components/application/List';
  import articleList from '../../components/article/marketingInfo';

  export default {
      name: 'home',
      mixins: [ListMixin,AccessMixin],
      components: {
        notificationList,
        productionList,
        qualityCheckList,
        ticketList,
        appList,
        articleList
      },
      data: () => ({
        userProfil: null,
      }),
      mounted() {
        if (! this.dataUser('profil')) {
          this.userGetData({data: 'profil'});
        } else {
          this.user = this.dataUser('profil');
        }
      },
      methods: {
        ...mapActions({
          userGetData: 'user/data'
        }),
      },
      computed: {
        ...mapState('user', {
          actioned: 'actioned',
          action: 'action',
          updatedata: 'updatedata',
          error: 'error',
          isLoading: 'isLoading',
        }),
        ...mapGetters('user',{
          dataUser: 'data',
        }),
        user: {
          get() { return this.userProfil },
           set(value) { this.userProfil = value; }
        },
        supervision() {
          if (this.user) {
            return this.user.supervision;
          }
          return false;
        }
      },
      watch: {
        updatedata: function (updatedata) {
          if (updatedata == 'profil') {
            this.user = this.dataUser('profil');
          }
        },
      }
  }
</script>
